import React from 'react';
import './App.css';
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import {MdEdit,MdSearch,MdCheckBox, MdCheckBoxOutlineBlank,MdCropOriginal,MdAddCircleOutline,MdVisibility,MdVisibilityOff,MdRemoveCircleOutline} from 'react-icons/md'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Alert from 'react-bootstrap/Alert'
//import {Form,Row,Col,Group} from 'react-bootstrap/Form'

class ProductItem extends React.Component {
	
    constructor(props){
        super(props);
        this.cards = {};        
    }

    getClassName(prod){
        return 'product-tiles-grid-item-image-wrapper flipCardInner ' + (prod.isPromo && prod.isErrorImg ?' bg-secondary': '')
    }

    getClassEdit(product){
        return "flipCard "  + (product.isEditing?"clicked":"");
    }

    getOverlay(overlayText){
        return( 
            <Tooltip>
                {overlayText}
            </Tooltip>
        );
    }

  	render() {
  		
  		return (
			<div className=""  >
                <div className={this.getClassEdit(this.props.product)}>
                    <div className={this.getClassName(this.props.product)}>
                        <div className="flipCardFront product-tiles-grid-item-image">

                            <div className="imageEditButton" style={{'display':(this.props.editable?'none':'none')}}>
                                <Button variant="outline-dark" onClick={()=>this.props.onEditProduct(this.props.product.pk)} className="btn btn-outline-light btn-sm">
                                    <MdEdit style={{width:'10px'}}/>
                                </Button>
                            </div>
                            <img onDoubleClick={(e)=>{this.props.onProductClick(this.props.product)}} height="316" src={this.props.product.imgUrl} alt="" className="rounded" />                         
                            <label style={{"display":(this.props.product.isPromo?'':'none')}}>Promo Component</label>                            
                        </div>
                        <div className="flipCardBack">
                            <Alert style={{height:'316px',zIndex:1}} key={"alertEdit"+this.props.product.pk} variant='warning'>
                                <form onSubmit={this.handleSubmit}>
                                    {/* BRAND */}
                                </form>
                            </Alert>
                        </div>
                        
                    </div>
                </div>
        		

            	<div draggable  onDragStart={e => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}  className="product-tiles-grid-item-info row" style={{'display':(this.props.editable?'':'none')}}>
            		<div className="col-md-12">
                        <ButtonGroup>
                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Add promo')}>
                                <Button variant="outline-dark" className="btn btn-outline-light btn-sm" onClick={(e) => this.props.onAddPromoClick(this.props.product)}>
                                    <MdCropOriginal/>
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Add product')}>
                                <Button variant="outline-dark" className="btn btn-outline-light btn-sm" data-toggle="modal" data-target="#prodModal" 
                                onClick={(e) => this.props.onAddProductClick(this.props.product)}>
                                    <MdAddCircleOutline/>
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Hide this product')}>        
                                <Button variant="outline-dark" className="btn btn-outline-light btn-sm" onClick={(e)=>this.props.onHideProduct(this.props.product)}>
                                    {this.props.product.isHidden?<MdVisibilityOff/>:<MdVisibility/>}
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Delete this product')}>
                                <Button variant="outline-dark" className="btn btn-outline-light btn-sm" onClick={(e) => this.props.onDeleteProductClick(this.props.product.code)}>
                                    <MdRemoveCircleOutline/>
                                </Button>                            
                            </OverlayTrigger>
                             <OverlayTrigger ref="searchOv" placement='bottom' overlay={this.getOverlay('Search promo image')}>
                                <Button style={{display:this.props.product.isPromo?'':'none'}} variant="outline-dark" onClick={(e)=>this.props.onSearchPromoImage(this.props.product)}>
                                    <MdSearch/>
                                </Button>
                            </OverlayTrigger>  
                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Select product')}>
                                <Button variant="outline-dark">
                                    <label htmlFor={"selProd"+this.props.product.pk}>
                                        {this.props.product.isSelected?<MdCheckBox/>:<MdCheckBoxOutlineBlank/>}
                                        <input id={"selProd"+this.props.product.pk} style={{display:'none'}} type="checkbox" checked={this.props.product.isSelected} onChange={(e)=>{this.props.onProductClick(this.props.product)}}/>            
                                </label>
                                </Button>
                            </OverlayTrigger>  
                             
                               
                            
                              
                        </ButtonGroup>
            			
					</div>
            		<div className="col-md-12 ">
                        <p>{this.props.product.description}</p>
                        <p className="allcopy">{this.props.product.code}</p>
    	        	</div>
        		</div>
			</div>
    	);
  	
  	}
}

export default ProductItem;